<span id="message" class="u-visually-hidden" role="alert" aria-live="assertive">{{ assertMessage }}</span>
<span id="politeMessage" class="u-visually-hidden" role="alert" aria-live="polite">{{ politeMessage }}</span>
